import ContactBlock from "../components/ContactBlock";
import Portfolio from "./Portfolio";
import { allWorkVideos } from "../data/videos";

function Work() {
  return (
    <main className="pageMain">
      <section className="section pageIntro">
        <h1>Work.</h1>
        <p>Music videos, creator-led content, brand pieces, trailers, promos, and reels.</p>
      </section>

      <Portfolio videos={allWorkVideos} />

      <ContactBlock title="Available for directing and content work." />
    </main>
  );
}

export default Work;
